import React, { type PropsWithChildren } from 'react';
import { cn } from '@/utils/tailwind.util';
export const ListLayoutWrapper = (props: PropsWithChildren<{
  className?: string;
}>) => {
  return <div className={cn('px-2xl py-lg max-mobile-lg:p-md max-tablet-lg:p-lg', 'flex justify-center', props.className)} data-sentry-component="ListLayoutWrapper" data-sentry-source-file="Layout.tsx">
      {props.children}
    </div>;
};
export const ListLayoutContainer = (props: PropsWithChildren<{
  className?: string;
}>) => {
  return <div className={cn('max-w-[1840px] w-full relative flex items-start flex-col bg-default', 'gap-md max-tablet-sm:gap-xs', props.className)} data-sentry-component="ListLayoutContainer" data-sentry-source-file="Layout.tsx">
      {props.children}
    </div>;
};